// 导出主要组件，并设置默认导出
export { default as UserDropdown } from './UserDropdown';
export { useUserDropdown } from './useUserDropdown';

// 导出子组件（可选，如果需要单独使用）
export { default as UserDropdownTrigger } from './UserDropdownTrigger';
export { default as UserProfileContent } from './UserProfileContent';
export { default as UserMenuItems } from './UserMenuItems';
export { default as SignOutModal } from './SignOutModal';

// 默认导出主组件，用于向后兼容 userDropdown.tsx 的导入方式
export { default } from './UserDropdown'; 